import { render } from "./Huoping.vue?vue&type=template&id=13cfb4d0&scoped=true"
import script from "./Huoping.vue?vue&type=script&lang=js"
export * from "./Huoping.vue?vue&type=script&lang=js"

import "./Huoping.vue?vue&type=style&index=0&id=13cfb4d0&scoped=true&lang=css"

import exportComponent from "E:\\work\\copy\\work\\fa\\tgkw\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13cfb4d0"]])

export default __exports__